import { createSelector } from 'reselect';
import get from 'lodash/get';
import getReturnPolicyDeleteConfirmation from './getReturnPolicyDeleteConfirmation';

const getOrganizationIdForReturnPolicyToBeDeleted = createSelector(
  getReturnPolicyDeleteConfirmation,
  (state) => get(state, 'organizationId'),
);

export default getOrganizationIdForReturnPolicyToBeDeleted;
